import React, { useState } from 'react'
import Avtar from '../../Images/no image.png'

function ViewBilling({ showViewModal, setShowViewModal, selectedSubscription }) {
    const [open, setOpen] = useState(showViewModal)

    const closeViewModal = () => {
        setOpen(false)
        setShowViewModal(false)
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[800px] h-[550px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    View Credit Details
                </h3>
                <form className="p-8">

                    <div className="w-full mt-4">
                        <label className='block mb-1 font-bold'>Image</label>
                        <img
                            src={selectedSubscription?.image || Avtar}
                            alt='Profile Pic'
                            className='h-32 w-32 object-cover rounded-full'
                        >
                        </img>
                    </div>

                    <div className="flex gap-2 ">
                        <div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Price</label>
                            <input
                                type="text"
                                name="phone"
                                className="border border-gray-800 p-2 w-full"

                                value={`$ ${selectedSubscription.price}`}
                                disabled
                            />
                        </div>
                        <div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Credits</label>
                            <input
                                type="text"
                                name="active"
                                className={`border border-gray-800 p-2 w-full`}

                                value={selectedSubscription.credit}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="w-full mt-4">
                        <label className="block mb-1 font-bold">Created Date</label>
                        <input
                            type="text"
                            name="active"
                            className={`border border-gray-800 p-2 w-full`}

                            value={new Date(selectedSubscription.createdAt).toLocaleString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            })}
                            disabled
                        />
                    </div>

                    <div className="flex justify-end gap-6 mt-6">
                        <button onClick={closeViewModal} className="bg-gray-300 border border-gray-800 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>


                    </div>

                </form>
            </div>
        </div>
    )
}

export default ViewBilling